import { Loader2, Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { Sprint } from "@/services/sprint.service";

export interface SprintRowHandlers {
	deletingId: string | null;
	updatingId: string | null;
	onActivate: (sprint: Sprint) => void;
	onComplete: (sprint: Sprint) => void;
	onEdit: (sprint: Sprint) => void;
	onAskDelete: (sprintId: string | null) => void;
	onDelete: (sprintId: string) => void;
}

export function SprintActions({
	sprint,
	deletingId,
	updatingId,
	onActivate,
	onComplete,
	onEdit,
	onAskDelete,
	onDelete,
}: SprintRowHandlers & { sprint: Sprint }) {
	const isUpdating = updatingId === sprint.id;

	if (deletingId === sprint.id) {
		return (
			<div className="flex items-center gap-2 shrink-0">
				<span className="text-xs text-muted">Delete?</span>
				<Button size="sm" variant="destructive" onClick={() => onDelete(sprint.id)}>
					Yes
				</Button>
				<Button size="sm" variant="outline" onClick={() => onAskDelete(null)}>
					No
				</Button>
			</div>
		);
	}

	return (
		<div className="flex items-center gap-2 shrink-0">
			{sprint.status === "planned" && (
				<Button size="sm" variant="outline" disabled={isUpdating} onClick={() => onActivate(sprint)}>
					{isUpdating && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
					Start Sprint
				</Button>
			)}
			{sprint.status === "active" && (
				<Button size="sm" variant="outline" disabled={isUpdating} onClick={() => onComplete(sprint)}>
					{isUpdating && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
					End sprint
				</Button>
			)}
			<Button
				size="icon"
				variant="ghost"
				aria-label="Edit sprint"
				className="h-8 w-8 text-muted hover:text-foreground"
				onClick={() => onEdit(sprint)}
			>
				<Pencil className="h-3.5 w-3.5" />
			</Button>
			<Button
				size="icon"
				variant="ghost"
				aria-label="Delete sprint"
				className="h-8 w-8 text-muted hover:text-danger"
				onClick={() => onAskDelete(sprint.id)}
			>
				<Trash2 className="h-3.5 w-3.5" />
			</Button>
		</div>
	);
}
